__turbopack_context__.v({
  "highlight-tag": "ProductHighlightTag-module-scss-module__1bBP5G__highlight-tag",
});
